import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ButtonComponent from '../../components/Button';
import InputComponent from '../../components/Input';
import { useDispatch } from 'react-redux';
import { AddFaqs } from '../../store/actions/user-action';
import { FaQuestion } from "react-icons/fa6";

const FAQPage = () => {
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues: {
      question: '',
      answer: ''
    },
    validationSchema: Yup.object({
      question: Yup.string()
        .required('Question is required')
        .min(10, 'Question must be at least 10 characters'),
      answer: Yup.string()
        .required('Answer is required')
        .min(10, 'Answer must be at least 10 characters'),
    }),
    onSubmit: async(values,formik) => {
     dispatch(AddFaqs(values,formik))
    },
  });

  useEffect(() => {
  }, [formik.values]);

  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
      <h3 className="font-medium">Add New Question</h3>
      <p className="text-sm text-[#595858] mt-2">
        In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content.
      </p>

      {/* Form starts here */}
      <form className="mt-5 w-2/3 m-auto" onSubmit={formik.handleSubmit}>
        <div className="mb-4">
          <label htmlFor="question" className="block text-sm font-medium leading-6 text-gray-900">
            Question
          </label>
          <InputComponent
           icon={<FaQuestion/>}
            type="text"
            name="question"
            value={formik.values.question} // Controlled input
            placeholder="Enter your Question"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.question && formik.errors.question && (
            <p className="text-red-500 text-sm">{formik.errors.question}</p>
          )}
        </div>

        <div className="mb-4">
          <label htmlFor="answer" className="block text-sm font-medium leading-6 text-gray-900">
            Answer
          </label>
          <textarea
            className="w-full h-32 border text-gray-900 rounded-md p-2"
            name="answer"
            value={formik.values.answer} // Controlled input
            placeholder="Enter your Answer"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          ></textarea>
          {formik.touched.answer && formik.errors.answer && (
            <p className="text-red-500 text-sm">{formik.errors.answer}</p>
          )}
        </div>
        
        <div className="mt-5 text-right rounded">
          <ButtonComponent text="Add this Question" type="submit" />
        </div>
      </form>
    </div>
  );
};

export default FAQPage;
